import { useEffect } from "react";
import { useUserSettings } from "@/hooks/use-user-settings";
import { isSupportedLanguage, normalizeLanguage } from "@/i18n/languages";
import { i18n, setAppLanguage } from "@/i18n";

interface UseLanguageSyncOptions {
  enabled?: boolean;
}

export function useLanguageSync(options: UseLanguageSyncOptions = {}): void {
  const { enabled = true } = options;
  const { settings } = useUserSettings({ enabled });

  useEffect(() => {
    if (!settings?.language) {
      return;
    }

    const targetLanguage = isSupportedLanguage(settings.language)
      ? settings.language
      : normalizeLanguage(settings.language);

    if (i18n.language !== targetLanguage) {
      void setAppLanguage(targetLanguage);
    }
  }, [settings?.language]);
}
